import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext } from 'react';
import { useDeuConsumptionContext } from '../../../../contexts/Billing/DeuConsumptionContext';
import DailyEngagedUsersContext from '../../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUsersTotalConsumedPaperContent } from '../styles';

const CompiledDailyEngagedUserOverspentContentComponent: React.FC = () => {
  const { content, currentMonth } = useContext(DailyEngagedUsersContext);
  const { compiledDailyEngagedUserDataState } = useDeuConsumptionContext();
  const compiledContainsDataOnSelectedMonth = compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth;
  const exceededPlan = compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.exceededPlan;

  return (
    <CompiledDailyEngagedUsersTotalConsumedPaperContent className="bg-color-surface-2">
      <BdsTypo tag="h4" variant="fs-16" bold="bold" margin={false}>
        {content.compiledDailyEngagedUserInformation.overspentMessages}
      </BdsTypo>
      <BdsTypo
        tag="h4"
        variant="fs-32"
        bold="bold"
        margin={false}
        data-exceededPlan={exceededPlan}
        className={currentMonth ? 'color-content-default' : 'color-primary'}
      >
        {exceededPlan >= 0 && compiledContainsDataOnSelectedMonth ? exceededPlan.toLocaleString(content.locale) : '--'}
      </BdsTypo>
    </CompiledDailyEngagedUsersTotalConsumedPaperContent>
  );
};

export default CompiledDailyEngagedUserOverspentContentComponent;
